
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "ImprovedBarkovichHIEMRI",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/ImprovedBarkovichHIEMRI.vue